import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  // Button,
  Card,
  CardContent,
  CardMedia,
  // CircularProgress,
  // Grid,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useSelector } from "react-redux";
import { isArray } from "lodash";

import { getAPI } from "../api/callAPI";
// import { useNavigate } from "react-router";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { SlCalender } from "react-icons/sl";
export default function UpcomingEvents({
  title,
  storeID,
  eventID,
  openEventDetails,
  setEventData,
}) {
  // const navigate = useNavigate();
  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(null);
  const [data, setData] = useState([]);

  const { endpoint } = useSelector((state) => state.auth);

  const getUpcomingEvents = useCallback(async () => {
    if (storeID) {
      setLoading(true);
      setError(null);
      try {
        // getUpcomingEvents: '/api/upcoming-events',
        const resp = await getAPI(endpoint, `upcoming-events?store=${storeID}`);

        if (eventID) {
          const selectedEvent = resp?.data?.find(
            (event) => String(event.slug) === String(eventID)
          );

          setEventData(selectedEvent);
        }

        if (resp.success) {
          if (isArray(resp.data) && resp.data.length > 0) {
            setData(resp.data);
          }
        }
      } catch (error) {
        console.error("getUpcomingEvents error >>> ", error);
        setData([]);
        setError("No Events yet");
      }
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint, eventID, storeID]);

  useEffect(() => {
    getUpcomingEvents();
  }, [getUpcomingEvents]);

  if (isLoading) {
    // return (
    //   <Box>
    //     <CircularProgress variant="indeterminate" />
    //   </Box>
    // );
    return null;
  }

  if (isError || !isArray(data) || data?.length === 0) {
    // return (
    //   <Box>
    //     <Typography variant="h6">No Upcoming Events</Typography>
    //   </Box>
    // );
    return null;
  }

  if (
    eventID &&
    isArray(data) &&
    data?.length === 1 &&
    String(data[0].slug) === String(eventID)
  ) {
    return null;
  }

  //   <Box
  //   display="flex"
  //   overflow="auto"
  //   gap={2}
  //   alignItems={"center"}
  //   justifyContent={"center"}
  //   container
  // >

  // const duplicatedData = [...data, ...data, ...data];
  // console.log("upcoming events", data);

  return (
    <>
      <Typography variant="h5" className="subtitle-main mt-5">
        {title}
      </Typography>

      <Box mt={2} width="100%" className="event-slider ">
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={20}
          slidesPerView={4}
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            0: {
              slidesPerView: 2,
            },
            500: {
              slidesPerView: 3.5,
            },
            899: {
              slidesPerView: 4,
            },
            1280: {
              slidesPerView: 4,
            },
          }}
        >
          {data.map((event, idx) => {
            const hideEvent = String(event.slug) === String(eventID);
            if (hideEvent) {
              return null;
            }
            const dateText = `${moment(event?.event_date).format(
              "DD MMM[,] YYYY"
            )}, ${moment(event?.time, "HH:mm:ss").format("h:mm a")}`;
            return (
              <SwiperSlide
                key={`event_${idx}_${storeID}`}
                onClick={() => {
                  openEventDetails(event);
                }}
                className="event-cursor"
              >
                <Card sx={{ minWidth: 300, mt: 1, mb: 1 }} className="">
                  <CardMedia
                    component="img"
                    height="300"
                    image={event.event_image || ""}
                    alt={event.name}
                  />
                  <CardContent>
                    <Typography
                      variant="h6"
                      color="text.primary"
                      fontWeight={"600"}
                    >
                      {event.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mt: 1 }}
                    >
                      <SlCalender /> {dateText}
                    </Typography>
                  </CardContent>
                </Card>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </Box>
    </>
  );
}
